import React from "react";
import {Cookies} from "react-cookie-consent";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {closeDialog} from "../../../slices/dialog";
import Button from "../../Common/Button";

export const CompanyProfileTutorial = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const onClose = () => {
        Cookies.set("profileTutorialDone", true, {expires: 1000});
        dispatch(closeDialog());
    };

    return (
        <div className="companyProfileTutorial">
            <h2 className="header mb10">{t("company_tutorial_profile_title")}</h2>
            <p className="default mb20">{t("company_tutorial_profile_text")}</p>
            <Button onClick={onClose}>{t("company_tutorial_profile_nextBtn")}</Button>
        </div>
    );
};
